import api from './api';

// Get all invoice templates
export const getInvoiceTemplates = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.type) params.append('type', filters.type);
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.ownership) params.append('ownership', filters.ownership);
  if (filters.companyId) params.append('companyId', filters.companyId);

  const response = await api.get(`/invoice-templates?${params.toString()}`);
  return response.data;
};

// Get a single template by ID
export const getInvoiceTemplateById = async (id) => {
  const response = await api.get(`/invoice-templates/${id}`);
  return response.data;
};

// Get default template for a type
export const getDefaultTemplate = async (type) => {
  const response = await api.get(`/invoice-templates/default?type=${type}`);
  return response.data;
};

// Create a new invoice template
export const createInvoiceTemplate = async (templateData) => {
  const response = await api.post('/invoice-templates', templateData);
  return response.data;
};

// Update an invoice template
export const updateInvoiceTemplate = async (id, templateData) => {
  const response = await api.put(`/invoice-templates/${id}`, templateData);
  return response.data;
};

// Delete an invoice template
export const deleteInvoiceTemplate = async (id) => {
  const response = await api.delete(`/invoice-templates/${id}`);
  return response.data;
};

// Set a template as default
export const setDefaultTemplate = async (id) => {
  const response = await api.patch(`/invoice-templates/${id}/set-default`);
  return response.data;
};

// Preview next invoice number
export const previewInvoiceNumber = async (templateId) => {
  const response = await api.get(`/invoices/preview-number?templateId=${templateId}`);
  return response.data;
};
